
/**
 * Helper functions for handling user names
 */

/**
 * Combines first_name and last_name into a full name
 * @param {Object} user User object with first_name and last_name properties
 * @returns {string} Full name
 */
export function getFullName(user) {
  if (!user) return '';
  
  const firstName = (user.first_name || '').trim();
  const lastName = (user.last_name || '').trim();
  
  // Prefer real names when available
  if (firstName || lastName) return `${firstName} ${lastName}`.trim();
  
  // Fallbacks: display_name -> email local-part
  const fallback = (user.display_name || '').trim() || (user.email ? user.email.split('@')[0] : '');
  
  return fallback || 'Unnamed User';
}

/**
 * Gets the initials from first_name and last_name
 * @param {Object} user User object with first_name and last_name properties
 * @returns {string} Initials
 */
export function getInitials(user) {
  if (!user) return '';
  
  const firstName = (user.first_name || '').trim();
  const lastName = (user.last_name || '').trim();
  
  if (firstName && lastName) return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
  if (firstName) return firstName.charAt(0).toUpperCase();
  if (lastName) return lastName.charAt(0).toUpperCase();
  
  const from = (user.display_name || '').trim() || (user.email ? user.email.split('@')[0] : '');
  return from ? from.charAt(0).toUpperCase() : '?';
}
